<template>
  <div>
    <table>
      <tr>
        <th>Referrals</th>
        <th>Bonus Months</th>
      </tr>
      <tr>
        <td>
          <div class="input-wrapper">
            <ArrowButton
              direction="left"
              :disabled="referrals === 0"
              @click="changeReferralCount(-1)"
            />
            <input type="number" v-model.number="referrals" class="referral-input" />
            <ArrowButton direction="right" @click="changeReferralCount(1)" />
          </div>
        </td>
        <td>
          {{ bonusMonthsCount }}
        </td>
      </tr>
    </table>

    <div class="message" v-if="referrals > 100">
      That's a lot of friends. I'm jealous.
    </div>
  </div>
</template>

<script>
import ArrowButton from './arrow-button'
import bonusCalculator from '../functions/referral-bonus-calc'

export default {
  name: 'PlansPage',
  components: {
    ArrowButton,
  },
  data() {
    return {
      referrals: 1,
    }
  },
  computed: {
    bonusMonthsCount() {
      return bonusCalculator(Math.floor(this.referrals))
    },
    monthsText() {
      return this.bonusMonthsCount === 0
        ? 'no bonus'
        : 'bonus ' + (this.bonusMonthsCount < 2 ? 'month' : 'months') + '!'
    },
  },
  methods: {
    changeReferralCount(delta) {
      const newCount = Math.floor(this.referrals + delta)
      this.referrals = Math.max(newCount, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.referral-input {
  width: 80px;
}
.input-wrapper {
  display: flex;
  align-items: center;
  padding: 5px;
  justify-content: space-between;
}
.message {
  text-align: center;
  padding: 20px;
}
</style>
